import * as d3 from 'd3';

export default class Simulation {
    constructor(el, callbackEvery, callbackRound, callbackDone) {
        this.el = el;
        this.callbackEvery = callbackEvery;
        this.callbackRound = callbackRound;
        this.callbackDone = callbackDone;

        this.container = d3.select(this.el);
        this.width = Math.floor(+this.container.style('width').replace('px', ''));
        this.height = this.width;

        this.radius = this.width / 2;
        this.ROOT_2 = Math.sqrt(2);

        this.inside = 0;
        this.outside = 0;

        this.setup();
    }

    setup() {
        this.canvas = d3
            .select(this.el)
            .append('canvas')
            .attr('width', this.width)
            .attr('height', this.height);

        this.context = this.canvas.node().getContext('2d');

        this.drawSquare();
        this.drawCircle();
    }

    drawSquare() {
        this.context.strokeRect(0, 0, this.width, this.height);
    }

    drawCircle() {
        this.context.beginPath();
        this.context.arc(this.radius, this.radius, this.radius, 0, Math.PI * 2, true);
        this.context.stroke();
    }

    addDataPoint(inside) {
        if (inside) {
            this.inside += 1;
        } else {
            this.outside += 1;
        }

        this.callbackEvery(this.inside, this.outside);

        if ((this.inside + this.outside) % this.roundInterval === 0) {
            this.callbackRound(this.inside, this.outside);
        }
    }

    start(limit, roundInterval, dotsPerSec) {
        this.limit = limit;
        this.roundInterval = roundInterval;
        this.dotsPerSec = dotsPerSec;

        this.context.globalAlpha = 0.8;

        this.interval = setInterval(() => {
            const point = {
                x: Math.random() * this.width,
                y: Math.random() * this.height
            };

            const distFromCenter = Math.sqrt(
                (point.x - this.radius) ** 2 + (point.y - this.radius) ** 2
            );

            if (distFromCenter < this.radius) {
                this.addDataPoint(true);
                this.context.fillStyle = '#b22222';
            } else {
                this.addDataPoint(false);
                this.context.fillStyle = '#386890';
            }
            this.context.beginPath();
            this.context.arc(point.x, point.y, 2.5, 0, Math.PI * 2, true);
            this.context.fill();

            if (this.inside + this.outside >= this.limit) {
                this.stop();
                this.callbackDone();
            }
        }, 1000 / this.dotsPerSec);
    }

    stop() {
        clearInterval(this.interval);
    }
}
